import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=4d46cac6&scoped=true&"
import script from "./AIChat.vue?vue&type=script&lang=js&"
export * from "./AIChat.vue?vue&type=script&lang=js&"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=4d46cac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46cac6",
  null
  
)

export default component.exports